import React from 'react';
import USPSection2Cards from '../../components/USPSection2/USPSection2Cards';

import CropYield from "../../assets/images/benefits/crop-yield.svg";
import CropQuality from "../../assets/images/benefits/improved-crop-quality.svg";
import CostEffective from "../../assets/images/benefits/cost-effective.svg";
import EnhancedSustainabilty from "../../assets/images/benefits/enached-sustainability.svg";
import ExpertSupport from "../../assets/images/benefits/expert-support.svg";
import FarmReputation from "../../assets/images/benefits/farm-reputation.svg";

import { Row, Col } from 'react-bootstrap';


const FarmerBenefits = () => {
    const benefits = [{
        title:"Increased Crop Yields",
        bodycopy:"Bees are critical to the pollination process. By introducing managed beehives, you can significantly increase fruit set and overall crop production. This translates to higher yields and more profitable harvests.",
        image:CropYield
    },
    {
        title:"Improved Crop Quality",
        bodycopy:"Pollination by healthy bee populations ensures that your crops mature uniformly, with better shape, size, and taste. Well-pollinated crops often command higher market prices due to their quality.",
        image:CropQuality
    },
    {
        title:"Cost-Effective & Natural",
        bodycopy:"Rather than relying on costly chemical solutions or manual pollination methods, using bees for natural pollination is a more cost-effective solution that supports the long-term sustainability of your farm.",
        image:CostEffective
    },
    {
        title:"Enhanced Sustainability",
        bodycopy:"Beekeeping provides a natural, eco-friendly way to improve crop yields while maintaining sustainable agricultural practices. Our approach reduces the need for pesticides and promotes biodiversity, making your farm more resilient and eco-conscious.",
        image:EnhancedSustainabilty
    },

    {
        title:"Expert Support & Peace of Mind",
        bodycopy:"ApisChain PSP provides ongoing support, from initial consultation to the end of the pollination season. We ensure that the bees are healthy and productive, so you can focus on other aspects of your farming operation without worrying about pollination.",
        image:ExpertSupport
    },
    {
        title:"Boosts Farm Reputation",
        bodycopy:"By integrating pollination services from ApisChain PSP, you’re showing that your farm is committed to high-quality, sustainable practices. This can improve your brand image, attract eco-conscious consumers, and help you tap into niche markets that value sustainability.",
        image:FarmReputation
    },

]
  return (
    <>  <Row>
    {benefits.map((e, index) => {
      return (
        <Col md={4} key={index}>
          <USPSection2Cards
            cardtitle={e.title}
            src={e.image}
            cardBodycopy={e.bodycopy}
          />
        </Col>
      );
    })}
  </Row></>
  )
}

export default FarmerBenefits